import {
  SERVICING_AUDIT_CHECK_DESCRIPTIONS,
  SERVICING_AUDIT_CHECK_LABELS,
  SERVICING_AUDIT_STATUS_LABELS,
  ServicingAuditCheck,
  ServicingAuditStatus,
} from '../../interfaces/servicingAudit'
import { FilterFieldType, IFilter } from './types'

const STATUS_OPTIONS = Object.values(ServicingAuditStatus).map((value) => ({
  value,
  label: SERVICING_AUDIT_STATUS_LABELS[value],
}))

const checkColumn = <TCheck extends ServicingAuditCheck>(field: TCheck) =>
  ({
    field,
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    align: 'center',
    title: SERVICING_AUDIT_CHECK_LABELS[field],
    description: SERVICING_AUDIT_CHECK_DESCRIPTIONS[field],
    options: STATUS_OPTIONS,
  }) as const

export const SERVICING_AUDIT_LIST_FILTERS_CONFIG = [
  {
    field: 'clientName',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Client',
    placeholder: 'Client',
    align: 'left',
  },
  checkColumn(ServicingAuditCheck.FacilityFee),
  checkColumn(ServicingAuditCheck.TermLoans),
  checkColumn(ServicingAuditCheck.Amendments),
  checkColumn(ServicingAuditCheck.MonthEndFees),
  checkColumn(ServicingAuditCheck.OveradvanceFee),
  checkColumn(ServicingAuditCheck.Maturity),
  checkColumn(ServicingAuditCheck.LoanBalance),
  {
    field: 'status',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    excludeColumn: true,
    title: 'Overall Status',
    options: STATUS_OPTIONS,
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      {
        title: 'With Issues',
        filters: { status: [ServicingAuditStatus.Fail, ServicingAuditStatus.Warning] },
      },
      { title: 'All', filters: {} },
    ],
  },
] as const satisfies IFilter[]
